export default function needApproval(ticket) {
  return (
    !ticket.AttachCustApproval &&
    ticket.SubStatus &&
    (ticket.SubStatus.trim() === 'Estimate-Submitted' ||
      ticket.SubStatus.trim() === 'Estimate-Submitted IC')
  );
}
